import { styled } from '../../../../../../core/theme/styled';

export const InfoContainer = styled.div`
  border-radius: ${(props) => props.theme.roundedCorners.large};
  border: 1px solid ${(props) => props.theme.palette.yellow.main};
  padding: ${(props) => props.theme.sizes.normal};
`;
